import {
  AccountMappingPath,
  CompleteSyncSetPath,
  CreateAndSubscribeGroupsPath,
  CreateGroupsPath,
  DashboardPath,
  EditGroupsPath,
  GroupsEmailRequestApprovalPath,
  ExternalAccountMappingPath,
  GroupsRequestPath,
  ManageGroupsPath,
  ReceivedGroupRequestsPath,
  RemapExternalAccountPath,
  RootPath,
  SentGroupRequestsPath,
  SplitExternalAccountMappingsPath,
  CreateLogicalAccountGroupingPath,
  OverrideLogicalAccountGroupingPath,
  LookupLogicalAccountGroupingPath,
  ManageLogicalAccountGroupingPath,
  SentLogicalAccountGroupingPath,
  ReceivedLogicalAccountGroupingPath,
  LagEmailRequestApprovalPath,
  BulkRegistrationPath,
  LookupHierarchyManagementPath,
  OrphanHierarchyManagementPath,
  // SubsidiaryHierarchyManagementPath,
  // ManageHierarchyManagementPath,
  // SentHierarchyManagementPath,
  // ReceivedHierarchyManagementPath,
  // IntelligentMatchPatch,
  // MarketingSearchPath,
  WorkflowHierarchyManagementPath,
  ManageAccountMappingPath,
  ImportExportPath,
  HMSEmailRequestApprovalPath,
  GoldenRecordManagementPath,
  ParentSubManagementPath,
  // StdNamesInReviewPath,
  AuditHistoryPath,
} from "./Routes";

const MainNavigationList = () => {
  const navigationList = [
    { id: 0, label: "Home", url: RootPath, rootMenu: "home" },
    {
      id: 1,
      label: "Multi-CRM Sync",
      url: AccountMappingPath,
      rootMenu: "mcs",
    },
    {
      id: 2,
      label: "Logical Account Grouping",
      url: LookupLogicalAccountGroupingPath,
      rootMenu: "lag",
    },
    {
      id: 3,
      label: "Hierarchy Management",
      url: GoldenRecordManagementPath,
      rootMenu: "hms",
    },
    {
      id: 4,
      label: "Groups",
      url: GroupsRequestPath,
      rootMenu: "groups",
    },
  ];

  return navigationList;
};

export default MainNavigationList;

export const BreadcrumbsRoutes = () => {
  const mainNavList = MainNavigationList();
  const routes = [
    ...mainNavList,
    {
      id: 6,
      label: "Group Requests",
      url: GroupsRequestPath,
      rootMenu: "groups",
      sideNav: true,
    },
    {
      id: 7,
      label: "Sent Group Requests",
      url: SentGroupRequestsPath,
      rootMenu: "groups",
    },
    {
      id: 8,
      label: "Received Group Requests",
      url: ReceivedGroupRequestsPath,
      rootMenu: "groups",
    },
    {
      id: 9,
      label: "Create and Subscribe Groups",
      url: CreateAndSubscribeGroupsPath,
      rootMenu: "groups",
      sideNav: true,
    },
    {
      id: 10,
      label: "Manage Groups",
      url: ManageGroupsPath,
      rootMenu: "groups",
      sideNav: true,
    },
    {
      id: 11,
      label: "Create Group",
      url: CreateGroupsPath,
      rootMenu: "groups",
    },
    {
      id: 12,
      label: "Edit Group",
      url: EditGroupsPath,
      rootMenu: "groups",
    },
    {
      id: 13,
      label: "Email request Approval",
      url: GroupsEmailRequestApprovalPath,
      rootMenu: "groups",
    },
    {
      id: 14,
      label: "Account Mapping",
      url: AccountMappingPath,
      rootMenu: "mcs",
      sideNav: true,
    },
    {
      id: 15,
      label: "External Account Mapping",
      url: ExternalAccountMappingPath,
      rootMenu: "mcs",
      sideNav: true,
    },
    {
      id: 16,
      label: "RemapFlip Accounts",
      url: RemapExternalAccountPath,
      rootMenu: "mcs",
    },
    {
      id: 17,
      label: "RemapSplit Accounts",
      url: SplitExternalAccountMappingsPath,
      rootMenu: "mcs",
    },
    {
      id: 18,
      label: "Complete sync",
      url: CompleteSyncSetPath,
      rootMenu: "mcs",
    },
    {
      id: 19,
      label: "LAG",
      url: LookupLogicalAccountGroupingPath,
      rootMenu: "lag",
      sideNav: true,
    },
    {
      id: 20,
      label: "Create LAG",
      url: CreateLogicalAccountGroupingPath,
      rootMenu: "lag",
    },
    {
      id: 21,
      label: "Override LAG",
      url: OverrideLogicalAccountGroupingPath,
      rootMenu: "lag",
    },
    {
      id: 22,
      label: "LAG Requests",
      url: ManageLogicalAccountGroupingPath,
      rootMenu: "lag",
      sideNav: true,
    },
    {
      id: 23,
      label: "Manage Sent LAG Requests",
      url: SentLogicalAccountGroupingPath,
      rootMenu: "lag",
    },
    {
      id: 24,
      label: "Manage Received LAG Requests",
      url: ReceivedLogicalAccountGroupingPath,
      rootMenu: "lag",
    },
    {
      id: 25,
      label: "Email request Approval",
      url: LagEmailRequestApprovalPath,
      rootMenu: "lag",
    },
    {
      id: 26,
      label: "Account Registration",
      url: BulkRegistrationPath,
      rootMenu: "mcs",
      sideNav: true,
    },
    {
      id: 27,
      label: "ECH",
      url: "ech",
      rootMenu: "hms",
      sideNav: true,
      disabled: true,
    },
    {
      id: 28,
      label: "Golden Record Management",
      url: GoldenRecordManagementPath,
      rootMenu: "hms",
      sideNav: true,
    },
    {
      id: 29,
      label: "Hierarchy Management",
      url: LookupHierarchyManagementPath,
      rootMenu: "hms",
      sideNav: true,
    },
    {
      id: 30,
      label: "Orphan Account Management",
      url: OrphanHierarchyManagementPath,
      rootMenu: "hms",
      sideNav: true,
    },
    {
      id: 31,
      label: "Import + Export",
      url: ImportExportPath,
      rootMenu: "hms",
      sideNav: true,
    },
    {
      id: 322,
      label: "GTMH",
      url: "gtmhtab",
      rootMenu: "hms",
      sideNav: true,
      disabled: true,
    },
    {
      id: 33,
      label: "Parent + Subsidiary Management",
      url: ParentSubManagementPath,
      rootMenu: "hms",
      sideNav: true,
    },
    {
      id: 34,
      label: "Generic",
      url: "generic",
      rootMenu: "hms",
      sideNav: true,
      disabled: true,
    },
    {
      id: 35,
      label: "Manage Workflows",
      url: WorkflowHierarchyManagementPath,
      rootMenu: "hms",
      sideNav: true,
    },
    {
      id: 36,
      label: "Audit History",
      url: AuditHistoryPath,
      rootMenu: "hms",
      sideNav: true,
    },
    {
      id: 37,
      label: "Manage Standardized Account",
      url: ManageAccountMappingPath,
      rootMenu: "crosssystemaccount",
    },
    {
      id: 38,
      label: "Email wf request Approval",
      url: HMSEmailRequestApprovalPath,
      rootMenu: "hms",
    },
    {
      id: 39,
      label: "Multi-CRM Sync Dashboard",
      url: DashboardPath,
      rootMenu: "mcs",
      sideNav: true,
    },
  ];

  return routes;
};
